import { render, staticRenderFns } from "./Admin-propietarios-list.vue?vue&type=template&id=aa5e1afe&"
import script from "./Admin-propietarios-list.vue?vue&type=script&lang=js&"
export * from "./Admin-propietarios-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports